import { Color } from './color';
/**
 * ▷◁
 */
export const HollowBowtie = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'stroke', symbol: 'bowtie' }, options), context);
};
HollowBowtie.props = Object.assign({ defaultMarker: 'hollowBowtie' }, Color.props);
//# sourceMappingURL=hollowBowtie.js.map